import { FillsGraphTimeSeriesData } from 'communication/types/fillsGraph/FillsGraphTimeSeriesData';
import {
    FillsGraphSnapData,
    FillsGraphCostUpdateData,
    FillsGraphVwapUpdateData,
} from 'communication/types/fillsGraph/FillsGraphElement';
import {
    FillsGraphOrderOpenData,
    FillsGraphOrderStatData,
    FillsGraphTotalBuyFillsData,
    FillsGraphTotalSellFillsData,
} from 'communication/types/fillsGraph/FillsGraphOrderStatData';
import { WidgetStreamState } from 'widgets/store/stream/WidgetStreamState';
import { StrategyParametersStreamDataState } from 'widgets/strategyParams/store/stream/StrategyParametersStreamState';
import { StreamDisableRangeDataState } from 'widgets/store/disableRange/StreamDisableRangeDataState';

export type FillsGraphStreamState = WidgetStreamState<FillsGraphDataState>;

export type FillsGraphStrategyParamData = Pick<
    StrategyParametersStreamDataState,
    'orderSelection' | 'paramGroups'
>;

export interface FillsGraphDataState extends StreamDisableRangeDataState {
    timeSeries: FillsGraphTimeSeriesData[];
    orderStat?: FillsGraphOrderStatData;
    snap?: FillsGraphSnapData;
    totalBuyFills?: FillsGraphTotalBuyFillsData;
    totalSellFills?: FillsGraphTotalSellFillsData;
    costUpdate?: FillsGraphCostUpdateData;
    vwapUpdate?: FillsGraphVwapUpdateData;
    strategyParams?: FillsGraphStrategyParamData;
    orderOpen?: FillsGraphOrderOpenData;
}

export const initialFillsGraphDataState: FillsGraphDataState = {
    timeSeries: [],
    disableRange: [],
};

export const initialFillsGraphStreamState: FillsGraphStreamState = {
    data: initialFillsGraphDataState,
    messages: [],
};
